require('./fiscalDocuments.scss');
const PropTypes = require('prop-types');
const React = require('react');
const { Component } = require('react');
const PureRenderMixin = require('react-addons-pure-render-mixin');
import Immutable from 'immutable';
import moment from 'moment';
import {sortByOrder} from 'lodash/collection';

// @components
const DocumentsTable = require('components/myProfile/documentsTable/documentsTable');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKBoxTitle } = require('commonsComponents/OKBoxTitle');

// @ constants
import { DATE_FORMAT_API } from 'constants/index';

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;


class FiscalDocuments extends Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    buildErrorState() {
        const { immDocuments } = this.props;
        const errorMessage = formatText('profileExtracts-errorMessage');
        const handleRequestDocuments = this.props.requestDocuments;

        const retryButton = (
            <OKButton
                id="btn_myProfileAdditionalDocumentationView_retry"
                onClick={handleRequestDocuments}
                loading={immDocuments.get('isFetching')}
            >
                <FormattedText value="profileExtracts-retry" />
            </OKButton>
        );

        return (
            <OKSectionBox>
                <EmptyState
                    button={retryButton}
                    primaryText={errorMessage}
                    iconType="nointernet-banking" />
            </OKSectionBox>
        );
    }

    buildTableDocuments(immFiscalDocuments) {

        const { maxNumberOfRows, immAccounts, callbackDownloadFile, callbackDownloadFiscalFile, showAutoDates } = this.props;

        let buttonShowAll;

        if (immFiscalDocuments.size > maxNumberOfRows) {
            buttonShowAll = (
                <div className="fiscal-documents__show-all">
                    <OKLink modifier="editorial" to={'/myprofile/taxAndRents/fiscalDocuments'} >
                        <FormattedText value="taxAndRents-seeAll" format="firstUppercase" />
                    </OKLink>
                </div>
            );
        }

        return (
            <div>
                <DocumentsTable
                    data={immFiscalDocuments}
                    showAlias={true}
                    immAccounts={immAccounts}
                    maxDocumentsToSee={maxNumberOfRows}
                    showDocumentationType={true}
                    callbackDownloadFile={callbackDownloadFile}
                    callbackDownloadFiscalFile={callbackDownloadFiscalFile}
                    showAutoDates={showAutoDates}
                />
                {buttonShowAll}
            </div>
        )
    }



    additionalDocumentationMapperToDocumentation = (document) => {
        const getValueByProperty = (additionalDocuments, prop) => {
            return additionalDocuments.get('fields').filter(field => field.get('name') === prop).first().get('value');
        }

        return {
            currentDocument: false,
            fechaAlta: moment(getValueByProperty(document, 'FECHADOCUM')).format(DATE_FORMAT_API),
            nombreTipoComunicacion: getValueByProperty(document, 'DENOMINACION'),
            isFetching: document.get('isFetching'),
            isFiscalFileType: true,
            file: {
                "process": document.get('process'),
                "internalIdx": document.get('internalIdx'),
                "segmentId": document.get('segmentId'),
                "pageTo": document.get('pageTo') || 0,
                "queryId": document.get('queryId')
            },
        };
    }

    buildDocuments() {

        const { immDocuments, additionalDocuments } = this.props;

        let documentsContainer;

        const documentsByGroup = immDocuments.get('documentsByGroup');
        const groupSelected = immDocuments.get('groupSelected');

        let documents = [];
        let additionalDocumentsList = []

        if (documentsByGroup.get(groupSelected)) {
            documents = documentsByGroup.get(groupSelected).get('documents');
        }

        if(additionalDocuments.size){
            const additionalDocumentsMapped = additionalDocuments.get('additionalDocumentation').map(document =>  this.additionalDocumentationMapperToDocumentation(document));

            additionalDocumentsList = Immutable.fromJS(additionalDocumentsMapped)
        }

        if (immDocuments.get('isPartialFetching')) {
            documentsContainer = <LoadingSection />;
        } else if (immDocuments.get('error')) {
            documentsContainer = this.buildErrorState();
        } else if (documents.size || additionalDocumentsList.size) {
            const mergedDocuments = [...documents.toJS(), ...additionalDocumentsList.toJS()];
            const sortedDocuments =  sortByOrder(mergedDocuments, ['fechaAlta'], ['desc']);
            documentsContainer = this.buildTableDocuments(Immutable.fromJS(sortedDocuments));
        } else {
            documentsContainer = (
                <EmptyState
                    primaryText={formatText('taxAndRents-noDocumentation')}
                    iconType="noitems-banking" />
            );
        }

        return documentsContainer;
    }

    render() {
        const documents = this.buildDocuments();
        const titleText = formatText('taxAndRents-fiscalDocuments');
        return (
            <div className="fiscal-documents">
                <OKBoxTitle value={titleText} />
                {documents}
            </div>
        );
    }
}

FiscalDocuments.defaultProps = {
    showAutoDates: true,
}

FiscalDocuments.propTypes = {
    immAccounts: PropTypes.object.isRequired,
    immDocuments: PropTypes.object.isRequired,
    additionalDocuments: PropTypes.object.isRequired,
    maxNumberOfRows: PropTypes.number,
    requestDocuments: PropTypes.func.isRequired,
    callbackDownloadFile: PropTypes.func.isRequired,
    callbackDownloadFiscalFile: PropTypes.func.isRequired,
    showAutoDates: PropTypes.bool
}

module.exports = FiscalDocuments;
